import {Image} from '@primer/react-brand/esm'

import {isFeatureEnabled} from '@github-ui/feature-flags'
import {
  OSAwareDownloadActionMenu,
  type OSAwareDownloadAction,
} from '@github-ui/swp-core/components/OSAwareDownloadActionMenu'
import {usePrefersReducedMotion} from '@github-ui/use-prefers-reduced-motion'

import confetti from './confetti.gif'
import {useMonaPixelAnimation} from './use-mona-pixel-animation'

import Styles from './DecoratedDownloadActionMenu.module.css'

type DecoratedDownloadActionMenuProps = {
  actions: readonly OSAwareDownloadAction[]
  menuLabel: string
  location: 'hero' | 'cta_banner' | 'highlight'
}

export function DecoratedDownloadActionMenu({actions, menuLabel, location}: DecoratedDownloadActionMenuProps) {
  const prefersReducedMotion = usePrefersReducedMotion()
  const hasPixelMonaEnabled = isFeatureEnabled('site_ghca_pixel_mona')
  const {downloadActionMenuRef, downloadButtonOverlayRef, downloadStatus, monaPixelRef} = useMonaPixelAnimation({
    enabled: hasPixelMonaEnabled,
    prefersReducedMotion,
  })

  return (
    <div ref={downloadActionMenuRef} className={Styles.DecoratedDownloadActionMenu}>
      {hasPixelMonaEnabled ? <Image ref={monaPixelRef} className={Styles.MonaPixel} src={confetti} alt="" /> : null}
      <OSAwareDownloadActionMenu
        actions={actions}
        menuLabel={menuLabel}
        analytics={{context: 'installer', location, tag: 'a'}}
        variant="primary"
      />
      {hasPixelMonaEnabled ? (
        <div ref={downloadButtonOverlayRef} className={Styles.ButtonOverlay}>
          <div className={Styles.ButtonOverlayItem} aria-hidden="true" />
          <div className={Styles.ButtonOverlayItem} aria-hidden="true" />
          <div className={Styles.ButtonOverlayItem} aria-hidden="true" />
          <div className={Styles.ButtonOverlayItem} aria-hidden="true" />
          <div className={Styles.ButtonOverlayItem} aria-hidden="true" />
          <div className={Styles.ButtonOverlayText} aria-hidden="true">
            {downloadStatus}
          </div>
        </div>
      ) : null}
    </div>
  )
}
